import React, { useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal } from "reactstrap"
import {
  ModalInputPhoneNumber,
  ModalVerificationCode,
  ModalVerificationMethod,
  ModalSuccessScreen,
  ModalExisitingSeller,
  ModalErrorScreen
} from "./ListOfModals"

//Actions
import { checkOtpCode } from "../../../actions/saleActions";
import { doFetchProfile } from '../../../actions/authAction';

// Store
import { connect } from "react-redux"

// Router
import { withRouter } from "react-router-dom"

const SellerVerification = (props) => {

  const [slug, setSlug] = useState("input-phone-number")
  const [verificationMethod, setVerificationMethod] = useState('')
  const [phoneId, setPhoneId] = useState(0)
  const [resendCode, setResendCode] = useState('')

  function _renderModal() {
    if (slug === "input-phone-number") {
      return (
        <ModalInputPhoneNumber
          isExistingSeller={props.isExistingSeller}
          setPhoneId={setPhoneId}
          doSubmitPhone={props.doSubmitPhone}
          phone={props.phoneNumber}
          toggle={props.toggle}
          setSlug={setSlug}
          setPhone={props.setPhone}
          dataPhone={props.dataPhone}
          payloadSubmitPhone={props.payloadSubmitPhone}
        />
      )
    } else if (slug === 'verification-method') {
      return (
        <ModalVerificationMethod
          setVerificationMethod={setVerificationMethod}
          doSentCitCall={props.doSentCitCall}
          doSentSMS={props.doSentSMS}
          phoneId={phoneId}
          toggle={props.toggle}
          setSlug={setSlug}
          dataSms={props.dataSms}
        />
      )
    } else if (slug === "verification-code") {
      return (
        <ModalVerificationCode
          phoneId={phoneId}
          phone={props.phoneNumber}
          history={props.history}
          doRefreshToken={props.doRefreshToken}
          phone={props.phoneNumber}
          verificationMethod={verificationMethod}
          dataPhoneUser={props.dataPhoneUser}
          doVerifyOtp={props.doVerifyOtp}
          checkOtpCode={props.checkOtpCode}
          doSentCitCall={props.doSentCitCall}
          doSentSMS={props.doSentSMS}
          toggle={props.toggle}
          setSlug={setSlug}
          setVerificationMethod={setVerificationMethod}
          dataVerify={props.dataVerify}
        />
      )
    } else if (slug === "success-screen") {
      return (
        <ModalSuccessScreen
          history={props.history}
          toggle={props.toggle}
          setSlug={setSlug}
          fetchProfile={props.fetchProfile}
        />
      )
    }
  }

  function renderExistingSeller() {
    return (
      <ModalExisitingSeller
        setIsOpenExistingModal={props.setIsOpenExistingModal}
        toggle={props.toggle}
        setSlug={setSlug}
        toggleExistingModal={props.toggleExistingModal}
        history={props.history}
      />
    )
  }

  return (
    <Modal
      centered className={"modal-seller__verification"}
      isOpen={props.isOpen}
      toggle={props.toggle}
    >
      {props.isExistingSeller && props.isOpenExistingModal ? renderExistingSeller() : _renderModal()}
    </Modal>
  )
}

const mapStateToProps = state => ({
  dataPhoneUser: state.dataOtp.dataPhoneUser.data,
  dataPhone: state.dataOtp.dataPhoneUser,
  dataVerify: state.dataOtp.dataVerify,
  dataSms: state.dataOtp.dataSms
})

const mapDispatchToProps = (dispatch: (arg0: any) => any) => ({
  checkOtpCode: (payload) => dispatch(checkOtpCode(payload)),
  fetchProfile: () => dispatch(doFetchProfile())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SellerVerification))